<div class="box-container">
  <mat-icon svgIcon="box-icon" class="icon"></mat-icon>
  <span class="item-count">{{ count }}</span>
</div>
